<template>
  <b-modal title="Detalhes do Checklist" v-model="show" size="xl">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="6">
          <b-form-group label="Detalhe:" label-for="detalhe" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="detalhe" v-model="template.detalhe" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Local:" label-for="local" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="local" v-model="template.local" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="6">
          <b-form-group label="Período:" label-for="periodo" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="periodo" v-model="template.periodo" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Resultado:" label-for="resultado" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="resultado" v-model="template.resultado" />
          </b-form-group>
        </b-col>
      </b-row>

      <hr />
      <b-row>
        <b-col cols="6">
          <b-form-group label="Responsável:" label-for="inspetor" label-cols-sm="3" label-align-sm="right">
            <b-form-select v-model="template.inspetor">
              <b-form-select-option v-for="profissional of getProfissionais" v-bind:key="profissional.id" :value="profissional"
                >{{ profissional.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useProfissionalStore } from "@/stores/ProfissionalStore";
import { storeToRefs } from "pinia";
import Checklist from "@/models_reports/Checklist";

export default {
  name: "ModalDeTemplateChecklist",

  components: {},

  data() {
    return {
      show: false,
      template: new Checklist(),
    };
  },

  methods: {
    call(checklist) {
      this.show = !this.show;
      this.template = checklist;
    },
  },

  setup() {
    const store = useSgcqStore();
    const profissionalStore = useProfissionalStore();
    const { getProfissionais } = storeToRefs(profissionalStore);

    return {
      store,
      profissionalStore,
      getProfissionais,
    };
  },
};
</script>

<style lang="scss" scoped></style>
